// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.DeletePaymentMethodWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { DeletePaymentMethodRequestDto, DeletePaymentMethodResponseDto } from '../..';

export const DeletePaymentMethodWebApiHandler_deletePaymentMethod_Path = '/api/web/v1/deletePaymentMethod';

/**
 * Delete a payment method
 */
export const DeletePaymentMethodWebApiHandler_deletePaymentMethod = (
  postData: DeletePaymentMethodRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, DeletePaymentMethodRequestDto, DeletePaymentMethodResponseDto>(
    {
      endpoint: DeletePaymentMethodWebApiHandler_deletePaymentMethod_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
